var _path, _path2, _path3, _path4, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExodus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 227,
    height: 230,
    viewBox: "0 0 227 230",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.623 64.2194L128.678 0V35.9054L191.51 76.735L184.118 100.125H128.678V129.875H184.118L191.51 153.265L128.678 194.095V230L226.623 165.986L210.607 115.103L226.623 64.2194Z",
    fill: "url(#paint0_linear_68_536)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.464 129.875H98.6991V100.125H43.2587L36.072 76.735L98.6991 35.9054V0L0.754395 64.2194L16.7705 115.103L0.754395 165.986L98.9044 230V194.095L36.072 153.265L43.464 129.875Z",
    fill: "url(#paint1_linear_68_536)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_68_536",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 227,
    height: 230
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M226.623 64.2194L128.678 0V35.9054L191.511 76.735L184.119 100.125H128.678V129.875H184.119L191.511 153.265L128.678 194.095V230L226.623 165.986L210.607 115.103L226.623 64.2194Z",
    fill: "url(#paint2_linear_68_536)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4643 129.875H98.6993V100.125H43.2589L36.0722 76.735L98.6993 35.9054V0L0.754639 64.2194L16.7708 115.103L0.754639 165.986L98.9047 230V194.095L36.0722 153.265L43.4643 129.875Z",
    fill: "url(#paint3_linear_68_536)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_68_536)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.875488,
    width: 224.25,
    height: 230,
    fill: "url(#paint4_linear_68_536)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_536",
    x1: 194.938,
    y1: 245.813,
    x2: 129.33,
    y2: -25.2585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_68_536",
    x1: 194.938,
    y1: 245.813,
    x2: 129.33,
    y2: -25.2585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_68_536",
    x1: 194.938,
    y1: 245.813,
    x2: 129.33,
    y2: -25.2585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_68_536",
    x1: 194.938,
    y1: 245.813,
    x2: 129.33,
    y2: -25.2585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B46F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BBFBE0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_68_536",
    x1: 15.2505,
    y1: 51.75,
    x2: 128.813,
    y2: 136.562,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.119792,
    stopColor: "#8952FF",
    stopOpacity: 0.87
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DABDFF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExodus);
export default __webpack_public_path__ + "static/media/exodus.45cad285ee2906f7e9aab52c7651c6ce.svg";
export { ForwardRef as ReactComponent };